
namespace Matrix.DataAudit {

	@Serenity.Decorators.registerClass()
	export class SecurityHistoryGrid extends SiteEntityGrid<SecurityHistoryRow, any> {
        protected getColumnsKey() { return 'DataAudit.SecurityHistory'; }
        protected getDialogType() { return SecurityHistoryDialog; }
        protected getIdProperty() { return SecurityHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityHistoryRow.localTextPrefix; }
        protected getService() { return SecurityHistoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
		}

		protected getButtons() {
			return super.getButtons().filter(x => x.cssClass != "add-button");
		}
    }
}